import { ChangeEvent } from 'react'
import { useTranslation } from 'next-i18next'

import useSettingsFormContext from '~/hooks/useSettingsFormContext'
import { BookingLanguage } from '~/types/booking'
import { SelectBoxHomGradient } from '~/components/SelectBoxHomGradient'

export default function SecondaryLanguage(): React.ReactElement {
  const { t } = useTranslation('booking')
  const { fields, setFields } = useSettingsFormContext()

  const handleOnChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    const newValue = event.target.value ? (event.target.value as BookingLanguage) : undefined
    setFields((prevState) => ({ ...prevState, languageSecondary: newValue }))
  }

  return (
    <div className="space-y-1 flex flex-col">
      <span className="text-xxs text-gray-light-fade">{t('bookingLanguage.descriptionSecondaryLanguage')}</span>
      <SelectBoxHomGradient name="language" onChange={handleOnChange} value={fields.languageSecondary ?? ''}>
        <option value="">{t('bookingLanguage.headerSecondaryLanguage')}</option>
        {Object.values(BookingLanguage).map((elem) => (
          <option key={elem} value={elem}>
            {t(`languages.${elem}` as const)}
          </option>
        ))}
      </SelectBoxHomGradient>
    </div>
  )
}
